import React, { Component } from 'react'
import { Polar } from 'react-chartjs-2'; 
import posts_per_hour from '../json/posts_per_hour_30.json'

var array_keys = new Array();
var array_values = new Array();

for (var key in posts_per_hour) {
    array_keys.push(key);
    array_values.push(posts_per_hour[key]);
}

let colors = []
for(var i=0; i<24; i++) {
  colors.push('#'+Math.floor(Math.random()*16777215).toString(16));
}

const data = {
	labels: array_keys,
	datasets: [{
        data: array_values,
        backgroundColor: colors
    }],
};

export class PostingTimeChart extends Component {
  render() {
    return (
      <div>
        <h2>发帖时间统计</h2>
        <Polar data={data} /> 
      </div>
    );
  }
}

export default PostingTimeChart  
